import { render, staticRenderFns } from "./ReviewComponent.vue?vue&type=template&id=236534e1"
import script from "./ReviewComponent.vue?vue&type=script&lang=js"
export * from "./ReviewComponent.vue?vue&type=script&lang=js"
import style0 from "./ReviewComponent.vue?vue&type=style&index=0&id=236534e1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports